import React, { ReactNode } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import styled from 'styled-components';

import { useBoolean } from 'hooks/useBoolean';

const TooltipTrigger = styled(Tooltip.Trigger)`
  all: unset;
  cursor: pointer;
  width: inherit;
`;
const TooltipArrow = styled(Tooltip.Arrow)`
  fill: #0350a2;
`;

const TooltipContent = styled(Tooltip.Content)`
  border-radius: 4px;
  padding: 8px 10px;
  z-index: 9999;
  color: white;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  width: 209px;
  background-color: #0350a2;
  will-change: transform, opacity;
`;

interface ICustomTooltipProps {
  content: string;
  children: ReactNode;
  delayDuration?: number;
  sideOffset?: number;
  tooltipContentClassName?: string;
  tooltipArrowClassName?: string;
  direction?: 'top' | 'right' | 'bottom' | 'left';
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const CustomTooltip = ({
  content,
  children,
  direction,
  sideOffset,
  tooltipContentClassName,
  tooltipArrowClassName,
  delayDuration,
  type,
}: ICustomTooltipProps) => {
  const [isEnabled, { on, off, toggle, redirectTo }] = useBoolean();

  return (
    <Tooltip.Provider delayDuration={delayDuration}>
      <Tooltip.Root open={isEnabled} onOpenChange={redirectTo}>
        <TooltipTrigger
          onClick={() => toggle()}
          onFocus={() => setTimeout(() => on(), 0)}
          onBlur={() => off()}
          type={type}
        >
          {children}
        </TooltipTrigger>
        <Tooltip.Portal>
          <TooltipContent
            side={direction}
            sideOffset={sideOffset}
            className={`${tooltipContentClassName} cursor-pointer`}
          >
            {content}
            <TooltipArrow className={tooltipArrowClassName} />
          </TooltipContent>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

CustomTooltip.defaultProps = {
  tooltipArrowClassName: '',
  tooltipContentClassName: '',
  direction: 'top',
  sideOffset: 0,
  delayDuration: 0,
  type: undefined,
};

export default CustomTooltip;
